module.exports = __webpack_public_path__ + "static/media/man@2x.26ec047a.jpg";